var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.72 24.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:16.32px;font-family:Lato-Heavy, Lato;font-weight:800;letter-spacing:-0.02em;}.cls-1,.cls-4,.cls-9{fill:#222c63;}.cls-2{letter-spacing:0em;}.cls-3{letter-spacing:-0.02em;}.cls-4{font-size:6.65px;font-family:Lato-Semibold, Lato;font-weight:600;}.cls-5{letter-spacing:-0.03em;}.cls-6{letter-spacing:-0.02em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:0em;}.cls-10{fill:#f3bd19;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(24.65 14.08)"
  }, "L", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 8.17,
    y: 0
  }, "ok3"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 35.96,
    y: 0
  }, "r")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(25.88 22.41)"
  }, "loc", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 8.61,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.9,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 15.43,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 17.75,
    y: 0,
    xmlSpace: "preserve"
  }, " si"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 23.96,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.37,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0,2.57v9.49H8.91V2.57ZM8.33,8.1a.76.76,0,0,1-1.45.11.85.85,0,0,1,.26-1L7,6.58,6.81,5.8a2.19,2.19,0,0,1,1.54,0l-.19.79-.11.66A.84.84,0,0,1,8.33,8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.42,2.57v9.2h9.33V2.57ZM19.2,8.13a.67.67,0,0,1-1.27.1.74.74,0,0,1,.23-.87l-.11-.56-.18-.69A1.91,1.91,0,0,1,18.55,6a1.85,1.85,0,0,1,.67.12l-.17.69L19,7.39A.7.7,0,0,1,19.2,8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.42,13.14v9.27h9.33V13.14Zm8.78,5.45a.69.69,0,0,1-.61.52.72.72,0,0,1-.66-.42.74.74,0,0,1,.23-.87l-.11-.56-.18-.69a1.91,1.91,0,0,1,.68-.12,2.09,2.09,0,0,1,.67.11l-.17.7-.09.59A.7.7,0,0,1,19.2,18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M0,12.85v9.56l8.91,1.66v-9Zm8.13,7a.59.59,0,0,1-.52.44.6.6,0,0,1-.55-.36.65.65,0,0,1,.19-.73l-.09-.47L7,18.1a1.8,1.8,0,0,1,.57-.1,1.56,1.56,0,0,1,.57.1L8,18.68l-.08.5A.57.57,0,0,1,8.13,19.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.66f69425d49f929c379ada4775e98927.svg";
export { ForwardRef as ReactComponent };